import React from 'react';
import { createBrowserHistory } from 'history';

import  {
	Modal,
	Button,
	Layout
} from "rhombus-react";

import "./NoIntegrationsModal.css";

export default function NoIntegrationsModal() {
	const history = createBrowserHistory();

	function renderNoContents(){
		return (
			<div className="no-integrations flex-center">
				<figure >
					<img src="/images/NoIntegrations.jpg" alt="No Integrations Icon" />
				</figure>
				<h4 className="message">Sorry, no social integrations have been added for this advertiser</h4>
			</div>
		);
	}

	function renderCloseFooter(){
		return (
			<Layout.ModalFooter>
				<Button theme="grey" onClick={closeModal}>Close</Button>
			</Layout.ModalFooter>
		);
	}

	function closeModal(){
		history.go(-1);
	}

	let modalProps = {
		title: `Social Concept`,
		type: "modal",
		className: "no-integrations-modal",
		xClose: true,
		allowFullScreen: false,
		bladeProps: {
			verticallyCenter: true,
		},
		renderContent: renderNoContents,
		renderFooter: renderCloseFooter,
		onClose: closeModal,
	};

	return <Modal {...modalProps} />;
}

NoIntegrationsModal.displayName = "NoIntegrationsModal";
